__turbopack_context__.v({
  "chip": "eDkemG_chip",
  "icon": "eDkemG_icon",
  "lg": "eDkemG_lg",
  "md": "eDkemG_md",
  "root": "eDkemG_root",
  "sm": "eDkemG_sm",
});
